// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__3_2rq","log":"ModalInventoryLogs_log__3N-vb","date":"ModalInventoryLogs_date__1ZEAX","userName":"ModalInventoryLogs_userName__2bE_2"};